function json2json(a){var b={data:{}};if(!a)return b;if('string'==typeof a)try{b.data=JSON.parse(a)}catch(a){b.error=a}else b.data=a;return b}function getJSONData(){return this.getChartData('json')}function setJSONData(a){this.setChartData(a,'json')}function wrapper(a){return a&&(a.prototype.setJSONData=setJSONData),a&&(a.prototype.getJSONData=getJSONData),{format:'json',toJSON:json2json,fromJSON:json2json}}export default{extension:wrapper,name:'JSON',type:'transcoder',requiresFusionCharts:!0};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-core/src/json-transcoder/index.js
// module id = null
// module chunks = 